import React from "react";

import {DatePicker} from "@mui/x-date-pickers/DatePicker/DatePicker.js";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider/LocalizationProvider.js";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs/AdapterDayjs.js";
import dayjs from "dayjs";

export const KPITimeRangeControls = ({
    activeWindow,
    disposition = "previous", // "previous" or "current"
    setUserDefinedWindow,
    userDefinedWindow,
}) => {

    return <>
        <span className="control">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker label="Baseline Start Date"
                    value={userDefinedWindow?.[disposition]?.start || activeWindow?.[disposition]?.start}
                    onChange={(newDate) => {
                        setUserDefinedWindow({
                            ...userDefinedWindow,
                            [disposition]: {
                                ...userDefinedWindow[disposition],
                                start: dayjs(newDate)
                            }
                        });
                    }}/>
            </LocalizationProvider>
        </span>
        <span className="control">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker label="Baseline End Date"
                    value={userDefinedWindow?.[disposition]?.end || activeWindow?.[disposition]?.end}
                    onChange={(newDate) => {
                        setUserDefinedWindow({
                            ...userDefinedWindow,
                            [disposition]: {
                                ...userDefinedWindow[disposition],
                                end: dayjs(newDate)
                            }
                        });
                    }}/>
            </LocalizationProvider>
        </span>
    </>
}


export default KPITimeRangeControls;